<div class="tree-select-container w-full">
    <div
        class="tree-select-input border-round border-1 py-2 px-3 flex justify-content-between align-items-center cursor-pointer"
        (click)="toggleDropdown()"
    >
        <div class="flex align-items-center w-full justify-content-between">
      <span class="placeholder text-500" *ngIf="facade.selectedNodes().length === 0">
        {{ placeholder }}
      </span>
            <span class="value text-900" *ngIf="facade.selectedNodes().length > 0">
        {{ displayLabel }}
      </span>

            <div class="flex align-items-center gap-2">
                <i
                    *ngIf="enableReset && facade.selectedNodes().length > 0"
                    class="pi pi-times text-500 cursor-pointer"
                    (click)="clearSelection($event)"
                ></i>
                <i
                    [ngClass]="facade.isOpen() ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                    class="text-500"
                ></i>
            </div>
        </div>
    </div>

    <!-- Dropdown -->
    <div
        class="tree-dropdown surface-0 shadow-2 border-round mt-1 overflow-auto"
        *ngIf="facade.isOpen()"
        style="max-height: 300px"
    >
        <div *ngIf="enableSearch" class="p-2">
            <input
                type="text"
                [(ngModel)]="search"
                placeholder="Buscar..."
                (ngModelChange)="facade.updateSearch($event)"
                class="p-inputtext w-full border-1 border-round p-2"
            />
        </div>

        <ul style="display: grid" class="list-none px-2 gap-3">
            <li
                id="noResultText"
                *ngIf="filteredNodes.length === 0"
                class="text-center text-sm text-500 py-2"
            >
                Sin resultados...
            </li>

            <app-tree-select-node
                *ngFor="let node of filteredNodes"
                [node]="node"
                [selectionMode]="selectionMode"
                [selectedNodes]="facade.selectedNodes()"
                (leafSelected)="onLeafSelect($event)"
            ></app-tree-select-node>
        </ul>
    </div>
</div>
